// Test IDs para el panel de conversaciones de WhatsApp (inbox del agente de IA).

export const CONVERSATIONS = {
  page: 'conversations-page',
  list: 'conversations-list',
  listEmptyState: 'conversations-list-empty-state',
  rowPrefix: 'conversations-row-', // + conversationId
  statusBadgePrefix: 'conversations-status-badge-',
  attentionDotPrefix: 'conversations-attention-dot-',
  filterAll: 'conversations-filter-all',
  filterBot: 'conversations-filter-bot',
  filterEscalated: 'conversations-filter-escalated',
  filterResolved: 'conversations-filter-resolved',
  filterUnread: 'conversations-filter-unread', // Fix BG (2026-11-04)
  unreadBadgePrefix: 'conversations-unread-badge-', // + conversationId (Fix BG)

  detailEmptyState: 'conversations-detail-empty-state',
  detailHeader: 'conversations-detail-header',
  detailStatusBadge: 'conversations-detail-status-badge',
  detailMessages: 'conversations-detail-messages',
  messageBubblePrefix: 'conversations-message-bubble-',
  replyInput: 'conversations-reply-input',
  replySendButton: 'conversations-reply-send-button',
  replyDisabledNotice: 'conversations-reply-disabled-notice',
  takeOverButton: 'conversations-take-over-button',
  resolveButton: 'conversations-resolve-button',
  reactivateBotButton: 'conversations-reactivate-bot-button',
  bookedAppointmentBadge: 'conversations-booked-appointment-badge',
  bookedAppointmentBadgePrefix: 'conversations-booked-appointment-badge-', // + conversationId (usado en la lista)
  // Fix AB (2026-10-15): anuncio desde el que escribio el cliente
  adReferral: 'conversations-ad-referral',
  adBadgePrefix: 'conversations-ad-badge-', // + conversationId (usado en la lista)
  // Fix AD (2026-10-15): etapa, etiquetas y servicio de interes del chat
  classificationBar: 'conversations-classification-bar',
  stageSelect: 'conversations-stage-select',
  serviceSelect: 'conversations-service-select',
  stageAiMark: 'conversations-stage-ai-mark',
  serviceAiMark: 'conversations-service-ai-mark',
  tagsMenuButton: 'conversations-tags-menu-button',
  tagOptionPrefix: 'conversations-tag-option-', // + etiqueta
  tagChipPrefix: 'conversations-tag-chip-', // + etiqueta
  filterStage: 'conversations-filter-stage',
  filterTag: 'conversations-filter-tag',
  filterService: 'conversations-filter-service',
  stageBadgePrefix: 'conversations-stage-badge-', // + conversationId
  rowTagPrefix: 'conversations-row-tag-', // + conversationId-etiqueta
  // Fix AE (2026-10-19): administrar etiquetas y Excel de contactos
  manageTagsButton: 'conversations-manage-tags-button',
  // Fix AG (2026-10-21): menu "Administrar listas" (etiquetas, etapas y servicios de interes)
  manageListsButton: 'conversations-manage-lists-button',
  manageStagesButton: 'conversations-manage-stages-button',
  manageInterestsButton: 'conversations-manage-interests-button',
  tagsDialog: 'conversations-tags-dialog',
  tagRowPrefix: 'conversations-tags-row-', // + posicion
  tagLabelInputPrefix: 'conversations-tags-label-input-', // + posicion
  tagUpPrefix: 'conversations-tags-up-', // + posicion
  tagDownPrefix: 'conversations-tags-down-', // + posicion
  tagHidePrefix: 'conversations-tags-hide-', // + posicion
  tagDeletePrefix: 'conversations-tags-delete-', // + posicion
  tagNewInput: 'conversations-tags-new-input',
  tagAddButton: 'conversations-tags-add-button',
  tagsSaveButton: 'conversations-tags-save-button',
  tagsError: 'conversations-tags-error',
  exportButton: 'conversations-export-button',
  exportDialog: 'conversations-export-dialog',
  exportFromInput: 'conversations-export-from-input',
  exportToInput: 'conversations-export-to-input',
  exportSummary: 'conversations-export-summary',
  exportDownloadButton: 'conversations-export-download-button',
  exportError: 'conversations-export-error',
  // Fix AF (2026-10-19): busqueda por telefono
  searchInput: 'conversations-search-input',
  searchClear: 'conversations-search-clear',
  // Fix AC (2026-10-15): plantillas de WhatsApp desde la plataforma
  templatesPageButton: 'conversations-templates-page-button',
  autoMessagesPageButton: 'conversations-auto-messages-page-button', // Fix AN (2026-10-23)
  autoOptOutChip: 'conversations-auto-opt-out-chip', // Fix AN: la paciente pidio no recibir mensajes automaticos
  autoOptOutAllowButton: 'conversations-auto-opt-out-allow-button',
  feedbackRowPrefix: 'conversations-feedback-row-', // Fix AO (2026-10-23) + messageId
  feedbackUpPrefix: 'conversations-feedback-up-', // + messageId
  feedbackDownPrefix: 'conversations-feedback-down-', // + messageId
  feedbackDialog: 'conversations-feedback-dialog',
  feedbackCommentInput: 'conversations-feedback-comment-input',
  feedbackCorrectionInput: 'conversations-feedback-correction-input',
  feedbackSaveButton: 'conversations-feedback-save-button',
  feedbackRemoveButton: 'conversations-feedback-remove-button',
  channelSwitch: 'conversations-channel-switch', // Fix AP (2026-10-23): responder por WhatsApp o por SMS
  channelWhatsapp: 'conversations-channel-whatsapp',
  channelSms: 'conversations-channel-sms',
  smsComposer: 'conversations-sms-composer',
  smsInput: 'conversations-sms-input',
  smsSendButton: 'conversations-sms-send-button',
  smsOptOutNotice: 'conversations-sms-opt-out-notice',
  smsTagPrefix: 'conversations-sms-tag-', // + messageId
  templatesPage: 'templates-page',
  templateNewButton: 'templates-new-button',
  templateRowPrefix: 'templates-row-', // + templateId
  templateEditPrefix: 'templates-edit-', // + templateId
  templateDeletePrefix: 'templates-delete-', // + templateId
  templateDeleteConfirm: 'templates-delete-confirm',
  templateFormDialog: 'templates-form-dialog',
  templateTitleInput: 'templates-title-input',
  templateLanguageSelect: 'templates-language-select',
  templateBodyInput: 'templates-body-input',
  templateVariablePrefix: 'templates-variable-', // + nombre / tratamiento / fecha / hora
  templateFooterInput: 'templates-footer-input',
  templateButtonInputPrefix: 'templates-button-input-', // + indice
  templateAddButton: 'templates-add-button',
  templateFormPreview: 'templates-form-preview',
  templateSaveButton: 'templates-save-button',
  // Fix N (2026-09-30): adjuntos, notas de voz y ventana de 24 h
  attachButton: 'conversations-attach-button',
  fileInput: 'conversations-file-input',
  pendingFile: 'conversations-pending-file',
  voiceRecordButton: 'conversations-voice-record-button',
  voiceRecordingBar: 'conversations-voice-recording-bar',
  voiceCancelButton: 'conversations-voice-cancel-button',
  voiceSendButton: 'conversations-voice-send-button',
  windowClosedNotice: 'conversations-window-closed-notice',
  // Fix AS (2026-10-27): link de reserva armado por el equipo
  bookingLinkButton: 'conversations-booking-link-button',
  bookingLinkDialog: 'conversations-booking-link-dialog',
  bookingLinkService: 'conversations-booking-link-service',
  bookingLinkInsertButton: 'conversations-booking-link-insert-button',
  bookingLinkError: 'conversations-booking-link-error',
  // Fix O (2026-09-30): plantillas y conversacion nueva
  templateButton: 'conversations-template-button',
  newConversationButton: 'conversations-new-conversation-button',
  templateDialog: 'conversations-template-dialog',
  templateSelect: 'conversations-template-select',
  templateParamPrefix: 'conversations-template-param-', // + nombre del dato
  templatePreview: 'conversations-template-preview',
  templateEmpty: 'conversations-template-empty',
  templatePhoneInput: 'conversations-template-phone-input',
  templateNameInput: 'conversations-template-name-input',
  templateSendButton: 'conversations-template-send-button',
  // Fix Q (2026-10-01): interruptores del agente
  agentGlobalSwitch: 'conversations-agent-global-switch',
  agentGlobalStatus: 'conversations-agent-global-status',
  agentChatSwitch: 'conversations-agent-chat-switch',
  // Fix AH (2026-10-21): aviso de llamada de WhatsApp
  callCard: 'whatsapp-call-card',
  callAnswerButton: 'whatsapp-call-answer-button',
  callRejectButton: 'whatsapp-call-reject-button',
  callMuteButton: 'whatsapp-call-mute-button',
  callHangupButton: 'whatsapp-call-hangup-button',
  callStatus: 'whatsapp-call-status',
  callError: 'whatsapp-call-error',
  // Fix AI (2026-10-23): celular - chat a pantalla completa, volver a la lista y secciones plegables
  mobileChat: 'conversations-mobile-chat',
  backButton: 'conversations-back-button',
  filtersToggle: 'conversations-filters-toggle',
  classificationToggle: 'conversations-classification-toggle',
};

// Fix AN (2026-10-23): mensajes automaticos de WhatsApp (reglas, horario y registro)
export const AUTO_MESSAGES = {
  page: 'auto-messages-page',
  enabledToggle: 'auto-messages-enabled-toggle',
  fromHourSelect: 'auto-messages-from-hour-select',
  untilHourSelect: 'auto-messages-until-hour-select',
  saveHoursButton: 'auto-messages-save-hours-button',
  templatesWarning: 'auto-messages-templates-warning',
  newRuleButton: 'auto-messages-new-rule-button',
  rulesEmpty: 'auto-messages-rules-empty',
  ruleRowPrefix: 'auto-messages-rule-row-', // + ruleId
  ruleTogglePrefix: 'auto-messages-rule-toggle-', // + ruleId
  ruleEditPrefix: 'auto-messages-rule-edit-', // + ruleId
  ruleDeletePrefix: 'auto-messages-rule-delete-', // + ruleId
  ruleDeleteConfirm: 'auto-messages-rule-delete-confirm',
  ruleTemplateWarningPrefix: 'auto-messages-rule-template-warning-', // + ruleId
  formDialog: 'auto-messages-form-dialog',
  nameInput: 'auto-messages-name-input',
  triggerSelect: 'auto-messages-trigger-select',
  offsetValueInput: 'auto-messages-offset-value-input',
  offsetUnitSelect: 'auto-messages-offset-unit-select',
  whenSelect: 'auto-messages-when-select',
  templateSelect: 'auto-messages-template-select',
  templatePreview: 'auto-messages-template-preview',
  serviceCheckboxPrefix: 'auto-messages-service-checkbox-', // + serviceId
  activeToggle: 'auto-messages-active-toggle',
  saveButton: 'auto-messages-save-button',
  suggestionsToggle: 'auto-messages-suggestions-toggle',
  suggestionPrefix: 'auto-messages-suggestion-', // + clave
  logFilterSelect: 'auto-messages-log-filter-select',
  logEmpty: 'auto-messages-log-empty',
  logRowPrefix: 'auto-messages-log-row-', // + logId
  logRetryPrefix: 'auto-messages-log-retry-', // + logId
  // Fix AQ (2026-10-23): reglas que mandan por SMS
  channelWhatsapp: 'auto-messages-channel-whatsapp',
  channelSms: 'auto-messages-channel-sms',
  smsOffNotice: 'auto-messages-sms-off-notice',
  smsLanguageSelect: 'auto-messages-sms-language-select',
  smsSuggestionButton: 'auto-messages-sms-suggestion-button',
  smsTextInput: 'auto-messages-sms-text-input',
  smsVariablePrefix: 'auto-messages-sms-variable-', // + dato
  smsProblem: 'auto-messages-sms-problem',
  smsPreview: 'auto-messages-sms-preview',
  smsCounter: 'auto-messages-sms-counter',
  instructionsHint: 'auto-messages-instructions-hint',
  ruleChannelPrefix: 'auto-messages-rule-channel-', // + ruleId
  ruleSmsTextPrefix: 'auto-messages-rule-sms-text-', // + ruleId
  ruleSmsWarningPrefix: 'auto-messages-rule-sms-warning-', // + ruleId
  logChannelPrefix: 'auto-messages-log-channel-', // + logId
};
